import { css } from '@emotion/react';
import { Trans, t } from 'i18n';
import { Environment } from 'shared';

import { getMMBRoute } from '../../../utils/routes';
import { theme } from '../../theme';

/**
 * @params
 * 1. pnr: string;
 *    - booking reference.
 *
 * 2. lastName: string;
 *    - Last name of the first passenger.
 *
 * 3. config: (@params { MMB_ROUTE: string, ENV: Environment });
 *    - Object containing the route for manage my booking and the current environment.
 **/

const styles = {
  infoBox: css`
    border-radius: ${theme.borders.radius.sm};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${theme.spacing.sm};
    background-color: ${theme.colors.background.container};
    gap: ${theme.spacing.md};
    padding: ${theme.spacing.md};
    > div {
      > p {
        margin: 0px;
        font-size: ${theme.fontSize.md};
      }
    }
    @media (max-width: ${theme.breakpoints.laptop}) {
      > a {
        > button {
          font-size: ${theme.fontSize.sm};
        }
      }
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
      flex-direction: column;
      align-items: center;
    }
  `,
  flexContainer: css`
    display: flex;
    align-items: center;
  `,
  myBookingsText: css`
    margin-left: ${theme.spacing.xs};
    margin-right: ${theme.spacing.xs};
    text-transform: uppercase;
    display: contents;
  `,
};

type Props = {
  pnr?: string;
  lastName?: string;
  clickable?: boolean;
  config:
    | {
        MMB_ROUTE: string;
        ENV: Environment;
      }
    | undefined;
};

export const MmbLink = ({ pnr, lastName, config, clickable = true }: Props) => {
  return (
    <div css={styles.infoBox}>
      <div css={styles.flexContainer}>
        <Trans i18nKey="visit.my.bookings" components={{ bold: <b css={styles.myBookingsText} /> }}>
          Go to my bookings to manage your booking or add travel extras for your trip.
        </Trans>
      </div>
      {
        <a
          aria-label="leads to manage my booking"
          href={
            clickable
              ? `${
                  config && getMMBRoute(config.ENV, config.MMB_ROUTE)
                }/itinerary?bookingreference=${pnr}&names=${lastName}`
              : '#'
          }
        >
          <button data-testid="go to manage-my-booking button">{t('manage.booking')}</button>
        </a>
      }
    </div>
  );
};
